module.exports = __webpack_public_path__ + "static/assets/a9eccab64d64a3114344d56af142741e.mp3";